import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useDeleteProviderField } from '../../hooks/useDeleteProviderField';

type ProviderFieldRowActionsProps = {
  rowId: string;
};

const ProviderFieldRowActions = ({ rowId }: ProviderFieldRowActionsProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const handleEdit = useParamsLink({ edit: rowId });
  const { mutate, isPending, error } = useDeleteProviderField(rowId, onClose);

  return (
    <Stack direction='row' spacing={1}>
      <EditRowActions onClick={handleEdit} />
      <DeleteRowAction
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        error={error}
        isLoading={isPending}
        onDelete={mutate}
      />
    </Stack>
  );
};

export default memo(ProviderFieldRowActions);
